<template>
  <div>
    <!-- <Header /> -->
    <div>
      <app-header />
    </div>
    <div class="layout container">
      <div id="main">
        <slot />
      </div>
    </div>
    <!-- <Footer /> -->
    <app-footer />
  </div>
</template>
<script>
import Footer from "@/components/Footer";
import Header from "@/components/Header";

export default {
  name: "Base-layout",
  components: {
    "app-footer": Footer,
    "app-header": Header
  }
};
</script>
<style lang="sass">
@import "@/assets/sass/global.sass"
.layout
  max-width: 1366px
</style>
